import React from 'react';
import {Bar} from 'react-chartjs-2';
import {Line} from 'react-chartjs-2';
import server from '../server';

class MoneyGraph extends React.Component{
  state = {
    graphData:{}
  }

  componentDidMount(){
      const user = JSON.parse(localStorage.getItem("user"));

      fetch(server.address + "/" + user.type + "/payments/" + user.id,{
        method:"GET",
        headers:{
            'Accept': 'application/json',
            'Content-Type':'application/json'
        },
      }).then(response => response.json().then(data => this.graph(data.payments)));
  }

  graph(data){
      let notConfirmedMoney = [0,0,0,0,0,0,0,0,0,0,0,0,0];
      let confirmedMoney = [0,0,0,0,0,0,0,0,0,0,0,0,0];
      for (let payment in data){
        const month = parseInt(data[payment].created_at.split("-")[1]) - 1;
        if(data[payment].confirmed){
          confirmedMoney[month] += data[payment].value;
        }else{
          notConfirmedMoney[month] += data[payment].value;
        }
      }

      let graphData = {
        labels : ["Janeiro","Fevereiro","Março","Abril","Maio","Junho",
        "Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],
        datasets: [{label:"Dinheiro Para Receber",
                    backgroundColor:"rgba(200,200,200,0.7)",
                    data: notConfirmedMoney},
                    {label:"Dinheiro Recebido",
                     backgroundColor:"rgba(0,255,0,0.7)",
                     data: confirmedMoney},]
      }

      this.setState({graphData:graphData});
  }

  render(){
    return(
      <div>
        <Bar height={250} width={500} data={this.state.graphData}/>
      </div>)
  }
}

export default MoneyGraph;



// WEBPACK FOOTER //
// ./src/graphs/MoneyGraph.js